import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { PatentContext } from "../context/PatentContextProvider";
import Sidenav from "../customcms/src/components/admin/SIdeNav";

export const PatentLicensing = () => {
    const { userData } = useContext(PatentContext);
    const [patents, setPatents] = useState([{ id: 1 }]);
    const [isSidenavOpen, setIsSidenavOpen] = useState(false); // For toggling sidenav visibility
    const [isLoading, setIsLoading] = useState(false);
    const [showValidation, setShowValidation] = useState(false);
    const userId = localStorage.getItem("userId");
    const handleInputChange = (index, newValue) => {
        const updatedPatents = [...patents];
        updatedPatents[index].value = newValue;
        setPatents(updatedPatents);
    };

    // const handleIncreasePatent = () => {
    //     const newId = patents.length ? patents[patents.length - 1].id + 1 : 1;
    //     setPatents([...patents, { id: newId, value: '' }]);
    // };

    const isValidUrl = (string) => {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const handleIncreasePatent = () => {
        const lastPatent = patents[patents.length - 1];
        if (!lastPatent.value.trim() || !isValidUrl(lastPatent.value.trim())) {
            setShowValidation(true);
            return;
        }

        const newId = lastPatent.id + 1;
        setPatents([...patents, { id: newId, value: '' }]);
        setShowValidation(false);
    };
 
    const handleRemovePatent = (index) => {
        const updatedPatents = patents.filter((_, i) => i !== index);
        setPatents(updatedPatents.length ? updatedPatents : [{ id: 1, value: '' }]);
    };

    useEffect(() => {
        const getPatents = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_PATH}/getPatentsById/${userId}`);
                const fetchedDetails = response.data.userPatents[0]?.patentDetails || [];

                const formattedPatents = fetchedDetails.map((patent, index) => ({
                    id: index + 1,
                    value: patent
                }));

                setPatents(formattedPatents.length ? formattedPatents : [{ id: 1 }]);
            } catch (error) {
                console.error("Error fetching patents:", error);
            }
        };

        if (userId) {
            getPatents();
        }
    }, [userId]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const lastPatent = patents[patents.length - 1];
        if (!lastPatent.value.trim() || !isValidUrl(lastPatent.value.trim())) {
            setShowValidation(true);
            return;
        }
        const patentValues = patents.map(p => p.value);
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_PATH}/patentLicensingData`, {
                patentDetails: patentValues,
                userId: userId
            });
            alert("Patents saved successfully");
        } catch (err) {
            console.error("Submit error:", err);
            alert(err.response?.data?.message || "Error saving patents");
        }
    }
    return (
        <>
            <div className="flex flex-col lg:flex-row bg-white min-h-screen w-full flex-nowrap">
                <div className="lg:hidden bg-gray-800 text-white p-4 flex justify-between items-center">
                    <h1 className="text-xl font-bold">All Blogs</h1>
                    <button
                        onClick={() => setIsSidenavOpen(!isSidenavOpen)}
                        className="text-white p-2 rounded-md bg-gray-700 hover:bg-gray-600"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                        </svg>
                    </button>
                </div>
                {/* Sidebar */}
                <div
                    className={`${isSidenavOpen
                        ? "fixed inset-0 transform translate-x-0 bg-gray-800"
                        : "fixed inset-0 transform -translate-x-full"
                        } lg:relative lg:translate-x-0 lg:w-52 text-white p-4 transition-transform z-50`}
                >
                    <Sidenav />
                    <button
                        onClick={() => setIsSidenavOpen(false)}
                        className="lg:hidden absolute top-4 right-4 text-gray-300 hover:text-white"
                    >
                        Close
                    </button>
                </div>
                {/* Main Content */}
                <div className="flex-1 ">
                    <div
                        className={`flex items-center justify-center py-10 pb-7 pt-14 transition-opacity duration-300 ${isSidenavOpen ? "opacity-50 pointer-events-none" : ""
                            }`}
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center min-h-screen w-full bg-white">
                                <div className="w-20 h-20 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
                            </div>
                        ) : (
                            <div className="pt-7 pl-2 w-full">
                                <div className="bg-white shadow-lg  shadow-gray-700 rounded-lg p-5 lg: space-y-6 w-[90%] mx-auto ">
                                    <div className="hidden lg:flex justify-between items-center bg-gray-800 p-4 -mt-12 rounded-lg">
                                        <h2 className=" text-white  font-semibold  ">Add patent</h2>
                                    </div>

                                    <div className="overflow-x-auto">
                                        <table className="w-full bg-white border-collapse rounded-lg shadow-lg">
                                            <tbody className="divide-y divide-gray-300">
                                                <div className="py-5">
                                                    <p>Patent number or Patent URL</p>
                                                    <form onSubmit={handleSubmit}>
                                                        <div className="w-[80%]">
                                                            {/* {patents.map((item, index) => (
                                                                <div className="py-1 flex items-center" key={item.id}>
                                                                    <input
                                                                        type="text"
                                                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                                                                        value={item.value}
                                                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                                                    />
                                                                    {index === patents.length - 1 ? (
                                                                        <button
                                                                            type="button"
                                                                            className="bg-blue-500 px-4 ml-2 rounded-lg text-2xl text-white"
                                                                            onClick={handleIncreasePatent}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className="bg-red-500 px-4 ml-2 rounded-lg text-2xl text-white"
                                                                            onClick={() => handleRemovePatent(index)}
                                                                        >
                                                                            −
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            ))} */}

                                                            {patents.map((item, index) => (
                                                                <div className="py-1 flex flex-col" key={item.id}>
                                                                    <div className="flex items-center">
                                                                        <input
                                                                            type="text"
                                                                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                                                                            value={item.value}
                                                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                                                        />
                                                                        {index === patents.length - 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="bg-blue-500 px-4 ml-2 rounded-lg text-2xl text-white"
                                                                                onClick={handleIncreasePatent}
                                                                            >
                                                                                +
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                type="button"
                                                                                className="bg-red-500 px-4 ml-2 rounded-lg text-2xl text-white"
                                                                                onClick={() => handleRemovePatent(index)}
                                                                            >
                                                                                −
                                                                            </button>
                                                                        )}
                                                                    </div>

                                                                    {/* Validation message for last input */}
                                                                    {index === patents.length - 1 && showValidation && (
                                                                        <>
                                                                            {!item.value.trim() ? (
                                                                                <p className="text-red-500 text-sm mt-1">Please fill out this field.</p>
                                                                            ) : !isValidUrl(item.value.trim()) && (
                                                                                <p className="text-red-500 text-sm mt-1">Please enter a valid URL (e.g. https://example.com).</p>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ))}


                                                            <div className="w-[20%] m-auto">
                                                                <button className="mt-2 bg-blue-500 px-4 py-1 rounded-md text-xl text-white" type="submit">Save</button>
                                                            </div>
                                                        </div>

                                                    </form>
                                                </div>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}